import isEmpty from 'lodash/isEmpty';

export const StartOrderComponent = {
    template: `
        <oo-loader class="landing-load" ng-if="!$ctrl.setupComplete"></oo-loader>
        <div class="landing-start-order-container fade-in" ng-show="$ctrl.setupComplete">
            <div class="text-left"
                ng-if="$ctrl.cartDisplay.enableOO && $ctrl.AuthenticationService.isAuthenticated()"
            >
                <span c-type="title-md-accent" class="welcome-text">
                    <ca-greeting></ca-greeting>
                </span>
                <a ng-click="$ctrl.logout()" class="pull-right">Log Out</a>
            </div>
            <modify-order></modify-order>
            <div ng-if="!$ctrl.cartDisplay.enableOO" class="text-center">
                <span class="glyph glyph-menu-icon"></span>
                <p c-type="title-md-primary">Online ordering is currently not available.</p>
                <p c-type="title-xs-primary">Feel free to browse our menu!</p>
                <br/>
            </div>

            <div class="form-spacing">
                <oo-button id="landing-start-order-button" is-loading="$ctrl.isLoading" types="button-primary button-full button-lg" button-click="$ctrl.updateCart()">
                    <span>
                        {{($ctrl.cartDisplay.restaurantAvailable &&
                            (($ctrl.locationData.inDeliveryRange && $ctrl.locationData.address === $ctrl.locationData.savedAddress) ||
                                $ctrl.cartDisplay.diningOption === 'TAKE_OUT')) ? "Start Your Order" : "Go To Menu"}}
                    </span>
                </oo-button>
            </div>

            <p class="go-to-login" ng-if="$ctrl.cartDisplay.enableOO && !$ctrl.AuthenticationService.isAuthenticated()">
                <a ui-sref="start.login">
                    Already a Member? Log in!
                </a>
            </p>
        </div>
    `,
    require: {
        abTest: '?^abTest'
    },
    controller: class {
        constructor(
            AuthenticationService,
            accountService,
            cartDisplayService,
            cartService,
            googleAnalyticsTrackingService,
            locationService,
            orderInfoService,
            ORDER_TYPES,
            paymentService,
            performanceService,
            $state
        ) {
            'ngInject';

            Object.assign(this, {
                AuthenticationService,
                accountService,
                cartDisplayService,
                cartService,
                googleAnalyticsTrackingService,
                ORDER_TYPES,
                orderInfoService,
                paymentService,
                performanceService,
                $state
            });

            this._startPerfTiming = this.performanceService.timingCategory('Landing Page');
            this._endSetupTiming = this._startPerfTiming('Setup');
            this.cartDisplay = cartDisplayService.displayData;
            this.isLoading = false;
            this.locationData = locationService.data;
        }

        $onInit() {
            this._endGoButtonClickableTiming = () => {};
            this.cartDisplayService.getDisplayData()
                .finally(() => {
                    this._endSetupTiming();
                    this.setupComplete = true;
                    this._endGoButtonClickableTiming = this._startPerfTiming('Go Button Clickable');
                });
        }

        updateCart() {
            if (this.abTest) {
                this.abTest.track('user', 'go-to-menu-click');
            }

            this._endGoButtonClickableTiming({
                analyticsLabel: 'clicked',
                analyticsIncludeNavigationStart: true
            });
            this.googleAnalyticsTrackingService.trackGoEvent(this.cartDisplay.diningOption);
            this.isLoading = true;

            if (!this.cartDisplay.restaurantAvailable) {
                this._goToOrderPage();
                return;
            }

            this.cartService.configureCart(
                this.cartDisplay.diningOption,
                this.cartDisplay.fulfillmentType,
                this.cartDisplay.fulfillmentMoment,
                false
            ).then(() => {
                if (this.cartDisplay.diningOption === this.ORDER_TYPES.DELIVERY) {
                    const deliveryInfo = this.orderInfoService.getDeliveryInfo();
                    if (!isEmpty(deliveryInfo)) {
                        return this.cartService.updateCart({
                            deliveryInfo,
                            paymentMethod: null,
                            skipCallout: true,
                            tipAmount: null
                        });
                    }
                }
                return $q.resolve();
            }).finally(() => {
                this.cartDisplayService.updateFulfillmentTimeFromCart();
                this._goToOrderPage();
            });
        }

        logout() {
            this.AuthenticationService.logout().then(() => {
                this.orderInfoService.clearAllData();
                this.paymentService.clearCreditCardPayment();
                this.accountService.clearLocalCustomerData();
            });
        }

        _goToOrderPage() {
            this.isLoading = false;
            this.$state.go('order');
        }

        _setRestaurantInfo(info) {
            this.restaurantInfo = info;
        }
    }
};
